<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="配额名称" property="quotaName">
									<el-input
										v-model="searchForm.quotaName"
										placeholder="输入配额名称"
										clearable
										@keyup.enter.native="getpe"
									>
									</el-input>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
							<el-button size="mini" type="primary" @click.native.prevent="getpe">查 询</el-button>
							<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
					</div>
					<hr class="search_border">
					<div class="search_tools_div">
						<div class="search_tools_text">数据列表</div>
						<div class="search-tools">
							<el-button type="primary" @click="addHandle">新增</el-button>
							<el-button :disabled="delBtlStatu" type="danger" @click="delHandle()">批量删除</el-button>
						</div>
					</div>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					  @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="50" align="center"></el-table-column>
						<el-table-column type="index" width="80" align="center" label="编号"></el-table-column>
						<el-table-column prop="quotaName" label="配额名称" show-overflow-tooltip align="center"></el-table-column>
						<el-table-column prop="quota" label="配额（度/床位）" show-overflow-tooltip align="center"></el-table-column>
						<el-table-column prop="roomCount" label="使用房间数" align="center">
							<template slot-scope="scope">
								<span :class="scope.row.roomCount?'green':'red'" class="border">{{ scope.row.roomCount || 0 }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="startDate" label="生效日期" sortable show-overflow-tooltip align="center"></el-table-column>

						<el-table-column
						  label="状态"
						  align="center"
						  show-overflow-tooltip
						>
							<template slot-scope="scope">
								<el-tag
								  :type="scope.row.statusFlag == 1 ? 'primary' : scope.row.statusFlag == 2 ? 'info' : 'warning'"
								  disable-transitions>{{ scope.row.statusFlag == 1 ? '生效中' : scope.row.statusFlag == 2 ? '已过期' : '未生效' }}
								</el-tag>
							</template>
						</el-table-column>

						<el-table-column
						  prop="icon"
						  fixed="right"
						  align="center"
						  label="操作">

							<template slot-scope="scope">

								<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
								<template>
									<el-popconfirm style="margin-left: 10px" title="确定要删除该配额吗？" @confirm="delHandle(scope.row.id)">
										<el-button type="text" slot="reference">删除</el-button>
									</el-popconfirm>
								</template>

							</template>
						</el-table-column>

					</el-table>

					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!--新增对话框-->
		<el-dialog
		  :title="title"
		  :visible.sync="dialogVisible"
		  width="700px"
		  :before-close="handleClose"
		  :close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px">

				<el-form-item label="配额名称" prop="quotaName">
					<el-input v-model="editForm.quotaName" placeholder="请输入配额名称" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="配额" prop="quota">
					<el-input v-model="editForm.quota" placeholder="请输入配额（度/床位）" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="生效日期" prop="startDate">
					<!-- <el-input v-model="editForm.startDate" placeholder="请选择生效日期" autocomplete="off"></el-input> -->
					<el-date-picker
						v-model="editForm.startDate"
						type="date"
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
						placeholder="请选择生效日期">
					</el-date-picker>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>


	</div>
</template>

<script>
import {getApi, addApi, delApi, getApi1, updateApi} from '../../apis/peie.js'
export default {
	name: "Peie",	// 配额管理
	data() {
		return {
			loading: true,

			searchForm: {},
			delBtlStatu: true,

			total: 0,
			size: 10,
			current: 1,

			dialogVisible: false,
			title: '新增',
			editForm: {},

			tableData: [],

			editFormRules: {
				quotaName: [
					{required: true, message: '请输入配额名称', trigger: 'blur'}
				],
				quota: [
					{required: true, message: '请输入配额', trigger: 'blur'}
				],
				startDate: [
					{required: true, message: '请选择生效日期', trigger: 'change'}
				]
			},

			multipleSelection: [],

			permDialogVisible: false,
			permForm: {},
			defaultProps: {
				children: 'children',
				label: 'machineNum'
			},
			treeSelectLocationId: 0,
			selectedMachineInfo: '',
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		this.getpe()
	},
	methods: {
		resetSearchForm() {
			this.searchForm = {}
			this.getpe()
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			// console.log("勾选")
			// console.log(val)
			this.multipleSelection = val;

			this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.size = val
			this.getpe()
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.current = val
			this.getpe()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		handleClose() {
			this.resetForm('editForm')
		},
		getpe() {
			this.loading = true
			getApi({current: this.current, size: this.size, ...this.searchForm}).then(res => res.data).then(res => {
				this.tableData = res.data.records
				this.total = res.data.total
				this.loading = false
			})
		},

		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// console.log(this.editForm);
					if (this.editForm.id) {
						updateApi({...this.editForm, quota: parseFloat(this.editForm.quota)}).then(res => {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
								onClose: () => {
									this.getpe()
								}
							});
							this.dialogVisible = false
						  	this.resetForm(formName)
						})
					} else {
						addApi({...this.editForm, quota: parseFloat(this.editForm.quota)}).then(res => {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
								onClose: () => {
									this.getpe()
								}
							});
							this.dialogVisible = false
						  	this.resetForm(formName)
						})
					}
				} else {
					// console.log('error submit!!');
					return false;
				}
			});
		},
		addHandle() {
			this.editForm = {}
			this.title = '新增电价'
			this.dialogVisible = true
		},
		editHandle(id) {
			this.title = '编辑电价'
			getApi1(id).then(res => res.data).then(res => {
				this.editForm = res.data
				this.dialogVisible = true
			})
		},
		delHandle(id) {
			var ids = []
			if (id) {
				ids.push(id)
			} else {
				this.multipleSelection.forEach(row => {
					ids.push(row.id)
				})
			}
			// console.log(ids);
			delApi(ids).then(res => res.data).then(res => {
				this.$message({
					showClose: true,
					message: '操作成功',
					type: 'success',
					onClose: () => {
						this.multipleSelection = []
						this.delBtlStatu = true
						this.getpe()
					}
				});
			})
		},
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}
</style>